import React from "react";

import AdminPageGuard from "../components/AdminPageGuard";
import Header from "./components/Header";
import UserTable from "./components/UserTable";
import "./users.scss";

function index() {
  return (
    <AdminPageGuard>
      <Header />
      <UserTable />
    </AdminPageGuard>
  );
}

export default index;
